import { html, View } from 'rune-ts';
import { EditCreatorProductData_TPL_INTL } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';

export class EditForm_TPL_INTL extends View<EditCreatorProductData_TPL_INTL> {
  protected override template() {
    return html` <div>EditForm_TPL</div> `;
  }
}
